import { FC, memo, ReactNode } from 'react';

import { array, dom, kind } from 'app/utils';
import { useUpdate } from 'app/hooks';
import { ILookup } from 'app/models';
import { Icon } from '../common';
import { IComponent, ISource } from '../types';
import { templates } from '../utils';

export interface IDisplay extends IComponent {
  value: any;
  source?: ISource['type'] | ISource;

  emptyText?: string;
}

const renderer = (item?: ILookup): ReactNode => {
  if (!item) return;

  const { value, label, attributes } = item;
  if (!attributes || kind.isEmptyObject(attributes)) return label;

  const { icon, color } = attributes;

  return (
    <span key={value} className="i-tag">
      <Icon name={icon} style={{ color }} />
      { label }
    </span>
  );
};

export const Display: FC<IDisplay> = memo(({ id, className, style, value, source, emptyText }) => {
  const forceUpdate = useUpdate();

  if (!source || typeof source === 'string') source = { type: (source ?? 'static') };
  const items = array.wrap(value).map(o => templates.source(source, o, forceUpdate)); // .filter(o => !!o);
  const children = items.map(renderer).filter(o => !!o);

  const props: any = { id, style,
    className: dom.className('i-component', 'i-display', { 'i-multiple': (children.length > 1) }, className),
  };

  return (
    <span { ...props }>
      { (children.length ? children : emptyText) }
    </span>
  );
});
